import "debounce";
import "tabbable";
import { useCurrentBreakPoint } from "../helpers/helper/hooks/use-current-breakpoint.mjs";
const getPlaceholderArray = (itemCount, breakPoint) => {
  const maxPlaceholderCount = 4 - itemCount;
  const defaultPlaceholderCount = getPlaceholderCount(breakPoint);
  const placeholderCount = Math.min(maxPlaceholderCount, itemCount === 0 ? defaultPlaceholderCount + 1 : defaultPlaceholderCount);
  return Array.from(Array(placeholderCount));
};
const getPlaceholderCount = (breakPoint) => {
  switch (breakPoint) {
    case "xs":
      return 1;
    case "sm":
      return 2;
    default:
      return 3;
  }
};
const getSlidesToShowAmount = (itemCount, maxItemCount) => {
  const minItemCount = itemCount < 4 ? itemCount + 1 : itemCount;
  if (maxItemCount > minItemCount) {
    return minItemCount;
  } else {
    return maxItemCount;
  }
};
const cellBEM = (isDifferent = false, isHidden = false) => {
  const classArray = ["product-comparison__table-cell"];
  if (isDifferent) {
    classArray.push("has-difference");
  } else {
    classArray.push("no-difference");
  }
  if (isHidden) {
    classArray.push("sr-only");
  }
  return classArray.join(" ");
};
const getItemInfoByCategoryItem = (categoryId, categoryItemId, item) => {
  const { data } = item;
  const category = data.find((c) => c.categoryId === categoryId);
  if (category) {
    return category.items.find((i) => i.id === categoryItemId);
  }
};
const usePlaceholderArray = (itemCount) => {
  const breakPoint = useCurrentBreakPoint();
  return getPlaceholderArray(itemCount, breakPoint);
};
const useSlidesToShowAmount = () => {
  const breakPoint = useCurrentBreakPoint();
  switch (breakPoint) {
    case "xs":
      return 2;
    case "sm":
      return 3;
    case "md":
    default:
      return 4;
  }
};
const useSliderSettings = (itemCount, options) => {
  return {
    arrows: false,
    dots: false,
    draggable: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: getSlidesToShowAmount(itemCount, 4)
        }
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: getSlidesToShowAmount(itemCount, 3)
        }
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: getSlidesToShowAmount(itemCount, 2)
        }
      }
    ],
    slidesToScroll: 1,
    slidesToShow: getSlidesToShowAmount(itemCount, 4),
    speed: 500,
    waitForAnimate: false,
    ...options
  };
};
export {
  cellBEM,
  getItemInfoByCategoryItem,
  getPlaceholderArray,
  getSlidesToShowAmount,
  usePlaceholderArray,
  useSliderSettings,
  useSlidesToShowAmount
};
